/**
 * Query keys do domínio lessons / aulas (apps/crm + apps/public).
 *
 * `viewScope` + `clubIds` participam da key porque a query de aulas
 * mudaem rede vs clube único (mesma justificativa de `students.list`).
 */
import { tuple } from "./core";
import type { StudentViewScope } from "./students";

const root = ["lessons"] as const;

export const lessons = {
  all: root,
  /** Lista de aulas; aceita scope (club|network) e lista de club ids efetivos. */
  list: (
    viewScope: StudentViewScope | { type: StudentViewScope } | null | undefined,
    clubIds: readonly string[] | null | undefined,
  ) => tuple(root, "list", viewScope, clubIds),
  byId: (lessonId: string | null | undefined) => tuple(root, "detail", lessonId),
  /** Alunos vinculados a uma aula (`club_lesson_students`). */
  students: (lessonId: string | null | undefined) =>
    tuple(root, "students", lessonId),
  /** Check-in / attendance de uma aula em uma data. */
  attendance: (lessonId: string | null | undefined, date: string | null | undefined) =>
    tuple(root, "attendance", lessonId, date),
  /**
   * Ocupação de uma aula num dia (RPC `ocupacao_da_aula`): matrículas,
   * presenças e experimentais da turma. `ocupacaoAll` é o prefixo que a
   * criação/cancelamento de experimental invalida.
   */
  ocupacaoAll: tuple(root, "ocupacao"),
  ocupacao: (lessonId: string | null | undefined, date: string | null | undefined) =>
    tuple(root, "ocupacao", lessonId, date),
  /**
   * Composição de várias ocorrências (RPC `composicao_das_aulas`, Agenda). Sob
   * o prefixo `ocupacao` de propósito: quem invalida `ocupacaoAll` (presença,
   * reposição, avulso, experimental) já atualiza os cards. Recebe o HASH dos
   * pares (ordenados), não os pares: uma semana de rede passaria de 40 KB.
   */
  composicao: (hashDosPares: string) =>
    tuple(root, "ocupacao", "composicao", hashDosPares),
  /**
   * Sinais da chamada (inadimplência / plano terminando) dos alunos de uma aula.
   * Os ids entram ordenados e unidos: a mesma turma em outra ordem é o mesmo cache.
   */
  signals: (lessonId: string | null | undefined, studentIds: readonly string[]) =>
    tuple(root, "signals", lessonId, [...studentIds].sort().join(",")),
} as const;
